import DqSidemenu from './src/sidemenu'

/* istanbul ignore next */
DqSidemenu.install = function (Vue) {
  Vue.component(DqSidemenu.name, DqSidemenu)
}

export default DqSidemenu



// WEBPACK FOOTER //
// ./src/dq-ui/packages/sidemenu/sidemenu.js